import { Hero } from "@/components/sections/Hero";
import { WhyChooseUs } from "@/components/sections/WhyChooseUs";
import { ServicesOverview } from "@/components/sections/ServicesOverview";
import { AboutPreview } from "@/components/sections/AboutPreview";
import { Testimonials } from "@/components/sections/Testimonials";
import { FAQ } from "@/components/sections/FAQ";
import { CTABanner } from "@/components/sections/CTABanner";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <WhyChooseUs />
      <ServicesOverview />
      <AboutPreview />
      <Testimonials />
      <FAQ />
      <CTABanner />
    </main>
  );
}
